import { Vue, Component, Prop } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { RenovationColor, RenovationColorList } from '../styleConfig';
import style from './style.vue';
import SelectIocnDialog from './selectIconDialog';
import { IPSService } from '@/services/ipsServices';
import validateParams from '@/library/utils/paramFilter';
import { noop } from '@/util';
import miniPageLink from '@/views/components/linkForm/miniPage';

export const navTypeToText = {
  QIKAN: 'HOT',
  SITE: '店铺',
  CLASSIFY: '分类',
  CART: '购物车',
  ACT: '活动',
  SALE: '发售',
  MINE: '我的',
  CUSTOM: '其他',
};

export enum NavConfig {
  IconText = 1,
  Icon,
  Text,
}
const ThemeInfoService = ['decorationThemeNavInfo', 'decorationThemeNavInfo', 'decorationThemeNavInfo', 'siteMenuNavInfo', 'decorationThemeNavInfo'];
const ThemeSaveService = ['decorationThemeNavSave', 'decorationThemeNavSave', 'decorationThemeNavSave', 'siteMenuNavSave', 'decorationThemeNavSave'];
const PageInfoService = ['miniPageInfo', 'miniPageInfo', 'miniPageInfo', 'siteMicroPageInfo', 'miniPageInfo'];
export interface PhoneNavType {
  isDefault: number;
  classId: string;
  isOpen: number;
  chooseClassId: string;
  className: string;
  sort: number;
  configType: string;
  _mouse?: boolean;
  _ref?: string;
  _select?: boolean;
  pageId?: number;
  pageName?: string;
  _isCustom?: number;
}

@Component({
  mixins: [style],
})
export default class NavMenu extends Vue {
  @Prop({ default: RenovationColor.redOrangeWhite })
    themeCode: number;

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Prop({ default: 2 })
    mode: number;

  // 网点组Id
  sgId: number;

  // 网点Id
  siteId: number;

  // @ts-expect-error
  theme = RenovationColorList[this.themeCode];

  phoneNavList: PhoneNavType[] = [];
  selectOpt: number = NavConfig.IconText;

  selectIcon = null;

  computedIsDisabled(): boolean {
    return this.phoneNavList.filter(v => v.isOpen).length >= 5;
  }

  mounted() {
    this.siteId = Number.parseInt(this.$route.params.siteId);
    this.sgId = Number.parseInt(this.$route.params.id) || Number.parseInt(this.$route.params.sgId);
    IPSService[ThemeInfoService[this.siteId ? 3 : 2]]({ postParams: { sgId: this.sgId, siteId: this.siteId } }).then((res) => {
      this.selectOpt = res.showType;
      this.phoneNavList = res.configList.map((i: any, index) => {
        i._mouse = false;
        i._select = i.configType === 'MINE';
        i._ref = `phoneNavList${index}`;
        if (!i.classId.includes('icon')) {
          i._isCustom = 1;
        } else {
          i._isCustom = 0;
        }
        return i;
      });
      const miniPage = this.phoneNavList.findIndex(v => v.configType === 'CUSTOM');
      if (miniPage > -1 && this.phoneNavList[miniPage].pageId) {
        IPSService[PageInfoService[this.siteId ? 3 : 2]]({
          postParams: {
            pageId: this.phoneNavList[miniPage].pageId,
          },
        }).then((response) => {
          this.phoneNavList[miniPage].pageName = response.pageName;
        });
      }
    });
  }

  openDialog(val: PhoneNavType) {
    SelectIocnDialog.open({
      type: val.configType,
      choseIcon: { icon: val.classId, choseIcon: val.chooseClassId },
      isCustom: this.mode === 2 ? val._isCustom : 0 || 0,
      mode: this.mode,
    }).then(
      (res) => {
        this.phoneNavList = this.phoneNavList.map((i) => {
          if (i.configType === val.configType) {
            i.classId = res.result.icon;
            i.chooseClassId = res.result.choseIcon;
            i._isCustom = res.type;
          }
          return i;
        });
      },
      () => {},
    );
  }

  setDefaultIndex(index: number) {
    this.phoneNavList = this.phoneNavList.map((v, i) => {
      v.isDefault = i === index ? 1 : 0;
      return v;
    });
  }

  save() {
    Promise.all(
      this.phoneNavList
        .filter(i => i.isOpen)
        .map((i) => {
          return new Promise((rej) => {
            (this.$refs[i._ref] as ElForm).validate((flag) => {
              rej(flag);
            });
          });
        }),
    ).then((res: boolean[]) => {
      if (res.every(i => i)) {
        IPSService[ThemeSaveService[this.siteId ? 3 : 2]]({
          postParams: {
            sgId: this.sgId,
            siteId: this.siteId,
            showType: this.selectOpt,
            configList: validateParams(this.phoneNavList),
          },
        }).then(
          (res) => {
            if (res.result) {
              this.$message.success('保存成功');
            } else {
              this.$message.error('保存失败');
            }
          },
          () => {
            this.$message.error('保存失败');
          },
        );
      }
    });
  }

  chooseLink(index) {
    miniPageLink.open({ sgId: this.sgId, siteCodes: [], siteId: this.siteId, mode: this.mode }).then((result) => {
      this.phoneNavList[index].pageId = result.id;
      this.phoneNavList[index].pageName = result.name;
    }, noop);
  }

  render(h) {
    return (
      <section class="nav-Menu">
        <p class="nav-title">底部菜单示意图</p>
        <div class="nav-container">
          <div class="left-phone wid-158">
            <div class="phone-nav-list">
              {this.phoneNavList
                .filter(i => i.isOpen)
                .map((val, index) => {
                  return (
                    <div class="phone-nav-item" key={index} style={{ backgroundColor: this.theme[2] }}>
                      {!val._isCustom
                        ? (NavConfig.Icon === this.selectOpt || NavConfig.IconText === this.selectOpt) && (
                          <i class={val._select && NavConfig.Text ? `iconfont ${val.chooseClassId}` : `iconfont ${val.classId}`} style={{ color: val._select ? this.theme[0] : '#777' }} />
                        )
                        : (NavConfig.Icon === this.selectOpt || NavConfig.IconText === this.selectOpt) && <img class="hei-14" src={val._select && NavConfig.Text ? val.chooseClassId : val.classId} />}
                      {(NavConfig.Text === this.selectOpt || NavConfig.IconText === this.selectOpt) && (
                        <span
                          class={{ text: true, bold: val._select && NavConfig.Text === this.selectOpt }}
                          style={{
                            color: val._select && NavConfig.Text !== this.selectOpt ? this.theme[0] : '#777',
                            fontSize: NavConfig.Text === this.selectOpt ? '16px' : '12px',
                          }}>
                          {val.className}
                          {val._select && NavConfig.Text === this.selectOpt && <i class="slider" style={{ backgroundColor: val._select ? this.theme[0] : '#777' }} />}
                        </span>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
          <div class="right-config">
            <div class="header">导航菜单</div>
            <div class="body overflow-auto-y" style="height:calc(100% - 50px);">
              <div class="bottom-nav-config">
                <p class="title">导航菜单</p>
                <el-radio-group v-model={this.selectOpt} class="radio-group flex no-wrap">
                  <el-radio label={1}>显示图标+文字</el-radio>
                  <el-radio label={2}>只显示图标</el-radio>
                  <el-radio label={3}>只显示文字</el-radio>
                </el-radio-group>
              </div>

              <div class="container">
                <draggable draggable={'.nav-config-item'} preventOnFilter={false} filter={'.navc-title'} scroll={true} v-model={this.phoneNavList} scroll-sensitivity={150} force-fallback={true} class="draggable">
                  {this.phoneNavList.map((val, index) => {
                    return (
                      <div
                        class="nav-config-item relative-position"
                        key={index}
                        onMouseover={() => {
                          val._mouse = true;
                        }}
                        onMouseout={() => {
                          val._mouse = false;
                        }}>
                        <p class="title">{navTypeToText[val.configType]}</p>
                        <div class="cont">
                          <div class="left">
                            {!val._isCustom ? <i class={'iconfont menu-icon' + ` ${val.classId}`} /> : <img class="hei-18 wid-18" src={val.classId} />}
                            <span class="modify" style={{ display: val.isOpen && val._mouse ? 'block' : 'none' }} onClick={this.openDialog.bind(this, val)}>
                              修改
                            </span>
                          </div>
                          <div class="right">
                            <p class="top" style="min-height:20px">
                              {val.configType !== 'MINE' && (
                                <el-checkbox v-model={val.isOpen} true-label={1} false-label={0} disabled={!!val.isDefault || (this.computedIsDisabled() && !val.isOpen)}>
                                  启用
                                </el-checkbox>
                              )}

                              {val.configType !== 'MINE' ? (
                                val.isDefault ? (
                                  <span class="default">
                                    <i class="iconfont iconmorenshouye text-orange-14" />
                                    默认首页
                                  </span>
                                ) : (
                                  <span class="set-default" style={{ display: val.isOpen && val._mouse ? 'block' : 'none' }} onClick={this.setDefaultIndex.bind(this, index)}>
                                    设为默认首页
                                  </span>
                                )
                              ) : (
                                ''
                              )}
                            </p>
                            <el-form props={{ model: val }} ref={val._ref}>
                              <p class="text">
                                <el-form-item class="navc-title" label="显示文字" prop="className" rules={[{ required: true, message: '请输入菜单文字' }]}>
                                  <el-input v-model={val.className} maxlength={4} disabled={!val.isOpen} />
                                </el-form-item>
                                {val.configType === 'CUSTOM' && (
                                  <el-form-item class="mr-t-10" label="页面展示" prop="pageId" rules={[{ required: true, message: '请选择微页面' }]}>
                                    <span class="scopeSpan" onClick={this.chooseLink.bind(this, index)}>
                                      {val.pageId ? `${val.pageId}-${val.pageName}` : '请选择'}
                                    </span>
                                  </el-form-item>
                                )}
                              </p>
                            </el-form>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </draggable>
              </div>

              <p class="tip blockTip r-mt-10">注1：选择不同页面风格时，底部菜单会进行自适应</p>
            </div>
          </div>
        </div>
        <div class="bottom-save">
          <el-button type="primary" onClick={this.save}>
            保存
          </el-button>
        </div>
      </section>
    );
  }
}
